import type { ImAccount } from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export const useGetApexAccounts = () => {
    return useGetAccounts({});
};

export const useGetPartnerSoloApexAccounts = (enabled: boolean) => {
    return useGetPartnerSoloAccounts({}, { enabled });
};

const useGetAccounts = requestBuilder.query<ImAccount[]>({
    endpoint: '/api/investments/accounts',
    queryKey: '/investments/accounts',
});

const useGetPartnerSoloAccounts = requestBuilder.query<ImAccount[]>({
    endpoint: '/api/investments/partner-solo-accounts',
    queryKey: '/investments/partner-solo-accounts',
});
